import { SVGProps } from 'react';

export const IconExpandFilled = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox='0 0 20 20' {...props}>
      <path d='M6 9L14 9L10 5L6 9Z' fill='currentColor' />
      <path d='M14 12H6L10 16L14 12Z' fill='currentColor' />
    </svg>
  );
};
